export default {
  root: {
    class: ['cursor-pointer', 'select-none'],
  },
}
